
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  data() {
    return {
      itemsAdvantage: [
        {
          principal: "Faire connaître notre client ",
        },
        {
          principal: "Apporter un nouveau souffle sur son image de marque",
        },
        {
          principal: "Faire grandir sa communauté",
        },
        {
          principal: "Développer sa notoriété",
        },
      ],
    };
  },

  head() {
    return {
      title: "Création de site internet pour Coiffeur | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Bellini Coiffure accueille ses clients, avec ou sans rendez-vous pour voir la vie en couleur. Avec notre équipage, nous avions plusieurs objectifs de trajectoire.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Site web, Référencement & Réseaux sociaux",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "Bellini Coiffure témoigne",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/case-studies/mockup-bellini-coiffure.jpg"),
        // },
      ],
    };
  },
};
